/* eslint-disable no-unused-vars */
export const enum CodeType {
  FILTER = 'FILTER',
  ATTRIBUTE = 'ATTRIBUTE',
}
